<template>
    <hr role="separator" :class="['eui-a-divider', { '-secondary': secondary }, { '-inset': inset }, { '-vertical': vertical } ]">
</template>

<script>
export default {
    name: 'Divider',
    props: {
        vertical: {
        type: Boolean,
        },
        secondary: {
            type: Boolean,
        },
        inset: {
            type: Boolean,
        },
    }
};
</script>